/**
 * The address an image the page hands to WebGL is fetched at, under the asset base: the look sheets of the world
 * (`looks/look-sheets.ts`) and of the Look panel's preview (`look-preview/plan.ts`), and the icon atlas the emoji over a
 * character are drawn from (`icons/page-icons.ts`). WebGL takes an image from another origin only when it was fetched
 * in CORS mode, and the live asset host's answers may be kept for a year. A browser that once fetched an asset's bare
 * path without CORS, as an `<img>` or a CSS background does, may hold that answer, which carries no
 * `Access-Control-Allow-Origin`, and serve it to a later CORS fetch of the same address, which then refuses it. The
 * query gives every such asset an address only ever fetched in CORS mode, so no such copy can answer it; the host
 * serves the same file whatever the query. An asset drawn only by the HTML overlay keeps its bare path.
 */

/**
 * The query every asset handed to WebGL is fetched with.
 */
export const CORS_QUERY = "cors=1";

/**
 * An asset's path under the asset base as it is fetched for WebGL.
 *
 * @param path The asset's path in its pointer.
 * @returns The path with the CORS query.
 *
 * @example
 * corsFetchPath("assets/looks/humn-3.0123456789abcdef.png"); // "assets/looks/humn-3.0123456789abcdef.png?cors=1"
 */
export function corsFetchPath(path: string): string {
  return `${path}?${CORS_QUERY}`;
}
